class SubmissionTracker {
  private static readonly STORAGE_KEY = 'paiperclip_submitted_responses';

  /**
   * Saves a submitted response ID to localStorage
   */
  public static saveSubmittedResponse(messageId: string): void {
    try {
      const submittedResponses = this.getSubmittedResponses();
      submittedResponses.push(messageId);
      
      // Save back to localStorage
      localStorage.setItem(
        this.STORAGE_KEY,
        JSON.stringify(submittedResponses)
      );
      
      console.log(`Saved message ID ${messageId} to submission tracker`);
    } catch (error) {
      console.error('Error saving submitted response:', error);
    }
  }

  /**
   * Checks if a response has already been submitted
   */
  public static checkIfSubmittedResponseExists(messageId: string): boolean {
    try {
      const submittedResponses = this.getSubmittedResponses();
      const exists = submittedResponses.includes(messageId);
      
      console.log(`Checking if message ID ${messageId} exists in submission tracker: ${exists}`);
      return exists;
    } catch (error) {
      console.error('Error checking if submitted response exists:', error);
      return false;
    }
  }

  /**
   * Retrieves all submitted response IDs from localStorage
   */
  private static getSubmittedResponses(): string[] {
    try {
      const storedValue = localStorage.getItem(this.STORAGE_KEY);
      if (storedValue) {
        return JSON.parse(storedValue);
      }
    } catch (error) {
      console.error('Error retrieving submitted responses:', error);
    }
    
    return [];
  }

  /**
   * Clears all submitted responses from localStorage
   */
  public static clearAllSubmittedResponses(): void {
    try {
      localStorage.removeItem(this.STORAGE_KEY);
      console.log('Cleared all submitted responses from tracker');
    } catch (error) {
      console.error('Error clearing submitted responses:', error);
    }
  }
}

export default SubmissionTracker;